import React from 'react';

const LogOut = () => {
  return (
    <div>
      <h1>Testing logout Page</h1>
    </div>
  );
};

export default LogOut;
